import { React, useRef } from "react";
import { useForm } from "react-hook-form";
import api from "../../api";
import { serializer } from "../../Serializer";

const ProductForm = () => {
  const upload = useRef();

  const uploadImage = () => {
    upload.image.click();
  };
  const defaultValues = {
    name: "",
    price: "",
    brand: "",
    category: "",
    description: "",
    image: null,
  };

  const { handleSubmit, register, reset } = useForm({
    defaultValues,
  });

  const onSubmit = (data) => {
    console.log("product", data);
    const formData = new FormData();
    formData.append("image", data?.image[0]);
    serializer(formData, data);
    console.log("sddsda", formData);
    api.post("/product/create", formData);
    // console.log("maila", resp);
    // reset();
  };
  return (
    <div className="productForm">
      <form onSubmit={handleSubmit(onSubmit)} enctype="multipart/form-data">
        <div className="row">
          <div className="col-md-6">
            <div className="form-cotrol">
              <label>Name</label>
              <input
                placeholder="eg. tubourge"
                type="text"
                name="name"
                {...register("name")}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-cotrol">
              <label>Price</label>
              <input
                placeholder="eg.500"
                type="text"
                name="price"
                {...register("price")}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-cotrol">
              <label>Brand</label>
              <input
                placeholder="eg. carlsberg"
                type="text"
                name="brand"
                {...register("brand")}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-cotrol">
              <label>category</label>
              <select
                placeholder="Catagories"
                name="category"
                {...register("category")}
              >
                <option name="Wishkey" value="whiskey">
                  Whiskey
                </option>
                <option name="Beer" value="beer">
                  Beer
                </option>
                <option name="Wine" value="wine">
                  Wine
                </option>
                <option name="Rum" value="rum">
                  Rum
                </option>
                <option name="SoftDrinksSnack" value="soft">
                  Soft Drinks & Snacks
                </option>
              </select>
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-cotrol">
              <label>Product Description</label>
              <textarea
                placeholder="Aaa.."
                id="description"
                name="description"
                rows="4"
                cols="100"
                {...register("description")}
              ></textarea>
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-cotrol">
              <label for="img">Select image:</label>
              <input
                type="file"
                name="image"
                accept="image/*"
                ref={upload}
                {...register("image")}
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-cotrol">
              <input type="submit" value="Add product" />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductForm;
